module.exports = __webpack_public_path__ + "static/img/row1.c0772e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/row1.png
// module id = 795k
// module chunks = 12